import {DateTime} from "luxon"

export const filialDoctors = {
  state: {
    doctorFilialId: null,
    allDoctorsList: [],
    currentFilialDoctorsList: [],
    otherFilialDoctorsList: [],
  },
  mutations: {
    setDoctorFilialId(state, val) {
      state.doctorFilialId = val
    },
    setFilialDoctorsLists(state, val) {
      state.allDoctorsList = val
      let eligibleDocs = []
      let currentFilialDocs = []
      let otherDocs = []

      const defaultFilialId = this.state.filials.defaultFilialId //ID филиала по умолчанию получаем из другого модуля Vuex

      //Сначала формируем список отображаемых элементов
      for (const doc of val) {
        let docX = {
          id: `${doc.doctorId}_${doc.filialId}`,
          doctorId: doc.doctorId,
          name: doc.doctorFio,
          note: doc.doctorNote,
          closestScheduleDate: DateTime.fromFormat(doc.closestScheduleDate, 'yyyy-MM-dd').toFormat('dd.MM.yyyy'),
          closestScheduleTime: DateTime.fromFormat(doc.closestScheduleTime, 'HH:mm:ss').toFormat('HH:mm'),
          closestScheduleDateTimeIso: `${doc.closestScheduleDate} ${doc.closestScheduleTime}`,
          filialId: doc.filialId,
          availableFilialIdList: [doc.filialId]
        }

        //Ищем в списке элемент с таким же doctorId
        let sameDocIndex = eligibleDocs.findIndex(it => it.doctorId === docX.doctorId)
        if (sameDocIndex === -1) {
          eligibleDocs.push(docX)
        } else {
          //Если нашли, сравниваем, чьё расписание - ближайшее
          const currentDocDT = DateTime.fromFormat(docX.closestScheduleDateTimeIso, 'yyyy-MM-dd HH:mm:ss')
          const sameDocDT = DateTime.fromFormat(eligibleDocs[sameDocIndex].closestScheduleDateTimeIso, 'yyyy-MM-dd HH:mm:ss')
          if (defaultFilialId === null) {
            if (currentDocDT < sameDocDT) {
              //Текущее расписание - ближайшее. Заменяем элемент внутри массива, добавляя ID филиала из старого элемента в availableFilialIdList
              docX.availableFilialIdList.push(eligibleDocs[sameDocIndex].filialId)
              eligibleDocs[sameDocIndex] = docX
            } else {
              //Текущее расписание - позже. Добавляем ID филиала текущего элемента availableFilialIdList старого элемента
              eligibleDocs[sameDocIndex].availableFilialIdList.push(docX.filialId)
            }
          } else if (docX.filialId === defaultFilialId) {
            //Текущий filialId - тот же, что и по умолчанию.
            //Такое расписание должно быть показано в списке,
            //поэтому заменяем элемент внутри массива, добавляя ID филиала из старого элемента в availableFilialIdList
            docX.availableFilialIdList.push(eligibleDocs[sameDocIndex].filialId)
            eligibleDocs[sameDocIndex] = docX
          } else {
            //Текущий filialId - не тот, что по умолчанию. Добавляем ID филиала текущего элемента availableFilialIdList старого элемента
            eligibleDocs[sameDocIndex].availableFilialIdList.push(docX.filialId)
          }
        }
      }

      //Теперь разделяем список отображаемых элементов на список текущего филиала и список других филиалов
      for (const doc of eligibleDocs) {
        if (defaultFilialId === null || doc.filialId === defaultFilialId) {
          currentFilialDocs.push(doc)
        } else {
          otherDocs.push(doc)
        }
      }

      state.currentFilialDoctorsList = currentFilialDocs
      state.otherFilialDoctorsList = otherDocs
    },
  },
  getters: {
    doctorFilialId(state) {
      return state.doctorFilialId
    },
    currentFilialDoctorsList(state) {
      return state.currentFilialDoctorsList
    },
    otherFilialDoctorsList(state) {
      return state.otherFilialDoctorsList
    }
  },
  actions: {
    recalculateFilialDoctors({commit, state}) {
      commit('setFilialDoctorsLists', state.allDoctorsList)
    }
  }
}